import { isMobileNumberValid } from '@afterpay/utils'
import { LegacyLocales, LegacyLocale, SupportedLocale } from '@afterpay/types'

export const isSupportedLocale = (locale: SupportedLocale | string | undefined): locale is SupportedLocale => {
  if (!locale) {
    return false
  }
  return !Object.values(LegacyLocales).includes(locale as LegacyLocale)
}

export interface getDefaultIdentityValueRequest {
  initMobileLogin: boolean
  mobile?: string
  lastMobile?: string
  mobileFromMerchant?: string
  email?: string
  skipPrefill?: boolean
}

export const getDefaultIdentityValue = ({
  initMobileLogin,
  mobile,
  lastMobile,
  email,
  skipPrefill = false,
}: getDefaultIdentityValueRequest): {
  defaultIdentityValue: string
  initMobileLoginState: boolean
} => {
  if (skipPrefill) {
    return {
      defaultIdentityValue: '',
      initMobileLoginState: false,
    }
  }

  if (initMobileLogin) {
    if (mobile && isMobileNumberValid(mobile)) {
      return {
        defaultIdentityValue: mobile,
        initMobileLoginState: true,
      }
    }
    if (lastMobile && isMobileNumberValid(lastMobile)) {
      return {
        defaultIdentityValue: lastMobile,
        initMobileLoginState: true,
      }
    }
  }
  return {
    defaultIdentityValue: email ?? '',
    initMobileLoginState: false,
  }
}

export const isSkipPrefill = (skipPrefillInUrl, skipPrefillIfNoAccountExist, isEmailExists, isMobileExists): boolean => {
  return skipPrefillInUrl || (skipPrefillIfNoAccountExist && !isEmailExists && !isMobileExists)
}
